// @flow
import React from 'react';
import styled from 'styled-components';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';

const Label = styled.label`
  display: inline-block;
  position: relative;
  padding-left: 33px;
  cursor: pointer;

  span,
  &:before,
  &:after {
    position: absolute;
    top: 50%;
    left: 0;
    height: 14px;
    border-radius: 14px;
    margin-top: -8px;
    content: '';
  }

  &:before {
    width: 24px;
    background-color: ${({ theme }) => theme.borderColor};
  }

  &:after {
    width: 12px;
    height: 12px;
    box-shadow: ${({ theme }) => theme.boxShadow};
    margin-top: -7px;
    background-color: #fff;
    transition: transform 0.3s;
  }

  span {
    display: block;
    opacity: 0;
    width: 24px;
    background-color: ${({ theme }) => theme.terciaryColor};
    transition: opacity 0.3s, width 0.3s;
  }
`;

/* stylelint-disable */
const Filter = styled.div`
  position: absolute;
  top: 0;
  right: 24px;
  ${maxMediaQueries.phone`
    right: 15px;
  `};
  input[type='checkbox'] {
    display: none;
  }
  input[type='checkbox']:checked + label {
    span {
      opacity: 1;
      transition: opacity 0.3s, width 0.3s;
    }
    &:after {
      transform: translateX(12px);
      transition: transform 0.3s;
    }
  }
`;
/* stylelint-enable */

type Props = {
  inputRef: Function,
  handleChange: Function
};

export const FollowingFilter = ({ handleChange, inputRef }: Props) => (
  <Filter>
    <input id="following" ref={inputRef} type="checkbox" name="following" value="true" onChange={handleChange} />
    <Label htmlFor="following">
      <span />
      Siguiendo
    </Label>
  </Filter>
);
